module.exports = __webpack_public_path__ + "static/media/Back-with-border.7ccb3e16.svg";